var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"leftLevelNavigation"}},_vm._l((_vm.navigation),function(item){return _c('div',{key:item.id,class:[
    'leftLevelNavigation-item',
    _vm.navId == item.id ? 'leftLevelNavigation-item-active' : '',
  ],on:{"click":function($event){return _vm.changeNav(item)}}},[_c('img',{attrs:{"src":_vm.navId == item.id ? item.iconActive : item.icon,"alt":""}}),_c('span',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }